<div class="flex flex-col justify-center items-center p-16 ">

  <h1 class="title-font sm:text-3xl text-2xl mb-4 font-medium text-gray-900">  මුදල් ගෙවීමට පෙර සලකිලිමත් විය යුතු කරුණු
    Things to consider before payment</h1>
    <p class="mb-4">
      Online මගින් ඇනවුම් කිරීමට පෙර තොග ඇත්දැයි <strong>0772553478</strong> <strong>Whatsapp</strong> හෝ <strong>දුරකථන ඇමතුමක්</strong> මගින් පරික්ෂා කර ගැනීම <strong>අනිවාර්ය වේ</strong>, සමහර විට stock out වී පැය 24ක් පමණ site එක update වීමට ගතවේ
    </p>
    <p class="mb-4">
      නිවසටම ගෙන්වා ගැනීමට අවශ්‍ය නම් මුදල් අපගේ <strong>Bank Account</strong> එකට <strong>Deposit</strong> කිරීම <strong>අනිවාර්ය වේ</strong>. අපගේ <strong>Cash on delivery</strong> සේවාව ක්‍රියාත්මක නොවේ, ඔබට අවශ්‍ය උපාංගයේ Model එක අප වෙත <strong>Whatsapp</strong> හෝ <strong>Massanger</strong> මගින් එවා stock තිබේදැයි පරික්ෂා කර ගන්න, ඔබ මිලදී ගන්න සෑම අයිතමයක් සඳහාම අදාළ <strong>Invoice Warranty</strong> පත එවනු ලැබේ
    </p>
    <p class="mb-6">
      පළමු 1KG එකක් සදහා <strong>රැ 500/=</strong> ක්ද වැඩිවන 1KG සදහා <strong>රැ 150</strong>ක්ද අය කරනු ලබයි, යම් හේතුවක් නිසා ඇනවුම ප්‍රමාද දෝෂයක් සිදු වුවහොත් අප ඔබ වෙත දන්වනු ඇත.
    </p>
  
    <p class="mb-4">
      Before ordering online, it is <strong>mandatory</strong> to check the stock availability by <strong>Whatsapp</strong> or <strong>phone call</strong> <strong>0772553478</strong>, sometimes it takes about 24 hours for the site to update after the stock is out.
    </p>
    <p class="mb-4">
      If you want to get it delivered to your home, it is <strong>mandatory</strong> to deposit the money into our <strong>bank account</strong>. Our <strong>Cash on delivery</strong> service is not available, send us the model of the device you want via <strong>Whatsapp</strong> or <strong>Messenger</strong> to check if it is in stock, the relevant <strong>Invoice Warranty</strong> card will be sent for every item you purchase.
    </p>
    <p class="mb-6">
      A charge of <strong>Rs. 500/=</strong> will be charged for the first 1KG and <strong>Rs. 150</strong> for each additional 1KG, if for some reason the order is delayed or damaged, we will inform you.
    </p>
  <div class="flex flex-row gap-2">
    <img class="w-20 contain  object-contain"  alt="sampath bank" src="../../../assets/branding/sampath-bank-logo-660B6E8BC9-seeklogo.com.png">

    <p class=" text-gray-900  text-left w-30">
      Bank : Sampath Bank <br>
      Name : Softnet Computers <br>
      A/C No : 008810001063 <br>
      Branch : Negombo 02 <br>
      Code : 88
    </p>
  </div>

  <br>
  <br>

  <!-- <div class="flex flex-row gap-2">
    <img class="w-20  object-contain" alt="sdb bank" src="../../../assets/branding/sdb bank.png">

    <p class=" text-gray-900  text-left w-30">
      Bank : SDB Bank<br>
      Name : K.A.L.G.Sarathchandra<br>
      A/C No : 000003364400<br>
      Branch : Negombo<br>
      Code : 27
    </p>
  </div>

  <br>
  <br> -->

  <div class="flex flex-row gap-2">
    <img class="w-20  object-contain"  alt="comercial bank" src="../../../assets/branding/comercial bank.png">


    <p class=" text-gray-900 text-left w-30">
      COMMERCIAL BANK<br>
      B H N N FERNANDO<br>
      8020360104<br>
      KATANA<br>
    </p>
  </div>



</div>
<app-footer></app-footer>